import styled from 'styled-components';
import {
  CardTitleAlt,
  TitleAndAction,
  ActionButton,
  ui,
  ButtonReset,
} from 'ui';
import { MdAdd, MdCheck, MdMoreVert } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { CardElement, CardElementContent } from '@tymate/sergic';

const CardTitle = styled(CardTitleAlt)`
  font-size: 18px;
`;

const DistributionListCard = ({
  displayName,
  count,
  countKind,
  isActive,
  onAdd,
}) => {
  const { t } = useTranslation();

  return (
    <CardElement isSemiPadded hasNoBottomMargin>
      <CardElementContent
        isBare
        as={isActive ? undefined : ButtonReset}
        onClick={isActive ? undefined : onAdd}
      >
        <TitleAndAction hasNoBottomMargin>
          <div>
            <CardTitle>{displayName}</CardTitle>
            <span style={{ color: ui('textLight') }}>
              {countKind === 'distributionLists'
                ? t('communications:nDistributionLists', { count })
                : t('communications:nContacts', { count })}
            </span>
          </div>
          {isActive ? (
            <ActionButton as="span" isReadOnly>
              <MdCheck />
            </ActionButton>
          ) : (
            <ActionButton as="span">
              {countKind === 'distributionLists' ? <MdMoreVert /> : <MdAdd />}
            </ActionButton>
          )}
        </TitleAndAction>
      </CardElementContent>
    </CardElement>
  );
};

export default DistributionListCard;
